import React from 'react'

const IconVisualizerExecutive = ({ width = '24', height = '24' }) => (
  <svg
    viewBox={`0 0 ${width} ${height}`}
    width={`${width}px`}
    height={`${height}px`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
      <path
        d="M12,10 C14.209139,10 16,11.790861 16,14 C16,15.0647454 15.5839866,16.0323256 14.905636,16.7490645 C16.6892551,17.7381734 17.91607,19.610125 17.9958615,21.7750617 L18,22 L6,22 L6.00413847,21.7750617 C6.08393,19.610125 7.31074494,17.7381734 9.09478152,16.7490089 C8.41601341,16.0323256 8,15.0647454 8,14 C8,11.790861 9.790861,10 12,10 Z M12,18 C10.5976787,18 9.35991367,18.7232685 8.64568166,19.8097769 L8.528,20 L15.464,20 L15.3707485,19.8449536 C14.6927317,18.7871583 13.53039,18.0707839 12.2006732,18.0049564 L12,18 Z M12,12 C10.8954305,12 10,12.8954305 10,14 C10,15.1045695 10.8954305,16 12,16 C13.1045695,16 14,15.1045695 14,14 C14,12.8954305 13.1045695,12 12,12 Z M7,2 L6.99982758,10.6824642 C6.72919508,11.0895447 6.50694844,11.5315672 6.34129768,12.0003218 L0,12 L0,2 L7,2 Z M24,2 L24,12 L17.6587023,12.0003218 C17.493188,11.5319533 17.271171,11.0902728 17.0008411,10.6834702 L17,2 L24,2 Z M5,4 L2,4 L2,10 L5,10 L5,4 Z M22,4 L19,4 L19,10 L22,10 L22,4 Z M15.5,2 L15.5009178,9.12670777 C14.9064132,8.69886844 14.2304448,8.37712937 13.5007383,8.18921631 L13.5,4 L10.5,4 L10.5002575,8.18895995 C9.7705827,8.37673053 9.09462146,8.69831019 8.50009038,9.12598236 L8.5,2 L15.5,2 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconVisualizerExecutive
